<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <SearchCollapse :is-bg-white="true" class="container py-4" :do-action="showCheckboxes">
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-12 md:col-span-3 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                        {{ $t('person.givenName') }}
                    </div>
                    <b-form-input
                        v-model="search.employeeGivenName"
                        class="focus:ring-0 border-gray-300 h-11"
                        @keyup.enter="searchEmployees"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-3 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                        {{ $t('person.familyName') }}
                    </div>
                    <b-form-input
                        v-model="search.employeeFamilyName"
                        class="focus:ring-0 border-gray-300 h-11"
                        @keyup.enter="searchEmployees"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-3 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                        {{ $t('person.telephone') }}
                    </div>
                    <b-form-input
                        v-model="search.employeeTelephone"
                        class="focus:ring-0 border-gray-300 h-11"
                        @keyup.enter="searchEmployees"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-3">
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                        <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchEmployees">
                    </button>
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                        <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetEmployeeSearchInfo">
                    </button>
                </div>
            </div>
            <div class="container d-md-none grid grid-cols-12">
                <div class="col-span-3">
                    {{ $t('filter.all') }}
                </div>
                <div class="col-span-6">
                    <b-form-checkbox
                        size="lg"
                        @change="selectAll"
                        :value="true"
                        :unchecked-value="false"
                        v-model="isSelectedAll"
                        class=""
                    />
                </div>

            </div>
        </SearchCollapse>

        <b-modal id="pay-modal" hide-footer hide-header>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="showSelectedModal()">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="hidePayModal">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <b-modal id="select-count-modal" hide-footer hide-header>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('kpi.salary.fromWhichCount') }}
            </div>
            <div class="">
                <b-form-select
                    :options="companyCounts"
                    required
                    text-field="name"
                    value-field="@id"
                    v-model="modelForm.companyCount"
                >
                </b-form-select>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button
                    :disabled="modelForm.companyCount === null"
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="paySalary">{{
                        $t('pay')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="hideSelectCountModal">
                    {{ $t('goBack') }}
                </button>
            </div>
        </b-modal>

        <b-modal id="pay-new-month-modal" hide-footer hide-header>
            <!-- Modal body -->
            <div class="modal-body">
                <h4>{{ $t('kpi.salary.payForNewMonth') }}</h4>
            </div>

            <HrRow class="mt-n4" />

            <div v-if="employee" class="form-row mb-4">
                <div class="col-12 px-3">
                    <div>
                        <span class="font-weight-bold">{{ $t('kpi.employee.title') }}:</span> {{ employee.givenName }} {{ employee.familyName }}
                    </div>
                    <div>
                        <span class="font-weight-bold">{{ $t('kpi.salary.title') }}:</span> {{ showCurrencyById(3, employee.employeeInformation.salary) }}
                    </div>
                    <div v-if="employee.employeeInformation.bonus">
                        {{ $t('kpi.bonus.title') }}: {{ showCurrencyById(3, employee.employeeInformation.bonus) }}
                    </div>
                </div>
            </div>

            <div class="form-row mb-5">
                <div class="d-flex justify-content-around">
                    <div class="col-4">
                        {{ $t('finance.fromCount') }}
                        <b-form-select
                            :options="companyCounts"
                            required
                            text-field="name"
                            value-field="@id"
                            v-model="modelForm.companyCount"
                        >
                        </b-form-select>
                    </div>
                    <div class="col-4">
                        {{ $t('kpi.salary.forWhatMonth') }}
                        <b-form-input
                            id="date"
                            type="month"
                            v-model="modelForm.salaryOf"
                        />
                    </div>
                    <div class="col-4">
                        {{ $t('kpi.salary.payedAmount') }}
                        <b-form-input
                            id="payedAmount"
                            type="number"
                            v-model="payedAmount"
                        />
                    </div>
                </div>
            </div>


            <!-- Modal footer -->
            <div class="modal-footer">
                <button
                    :disabled="!payedAmount || modelForm.companyCount === null"
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="payForNewMonth"
                >{{
                        $t('yes')
                    }}
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="$bvModal.hide('pay-new-month-modal')"
                >
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <!--  desktop version  -->
        <table class="w-full d-none d-md-table">
            <thead>
            <tr class="h-11 bg-lightGray">
                <th v-if="isShowCheckbox">
                    <b-form-checkbox
                        class="ml-3"
                        size="lg"
                        @change="selectAll"
                        :value="true"
                        :unchecked-value="false"
                        v-model="isSelectedAll"
                    />
                </th>
                <th class="d-none d-md-table-cell px-3">{{$t('id')}}</th>
                <th>{{ $t('name') }}</th>
                <th class="d-none d-xl-table-cell">{{ $t('employee.position') }}</th>
                <th class="d-none d-md-table-cell">{{ $t('employee.salary') }}</th>
                <th class="d-none d-md-table-cell">{{ $t('kpi.bonus.title') }}</th>
                <th>{{ $t('kpi.salary.payed') }}</th>
                <th>{{ $t('kpi.salary.forWhatMonth') }}</th>
                <th class="text-center" style="width: 300px">{{ $t('kpi.salary.pay') }}</th>
            </tr>
            </thead>
            <tbody v-for="(employee, index ) of getEmployeeSalaries" :key="index">
            <tr class="h-11 border-bottom">
                <td v-if="isShowCheckbox">
                    <b-form-checkbox
                        v-if="!isDisabledInput(employee)"
                        class="ml-3"
                        size="lg"
                        :value=employee.id
                        v-model="selectedEmployees"
                    />
                </td>
                <td class="d-none d-md-table-cell pl-3">
                    {{ employee.id }}
                </td>
                <td>
                    <div class="d-flex align-items-center text-main font-bold">
                        <img
                            :src="employee.image ? url + employee.image.contentUrl : ''"
                            style="border-radius: 50%;"
                            height="34px"
                            alt=""
                            @click="setModal(employee.givenName, url + employee.image.contentUrl)"
                            class="d-none d-md-table-cell"
                        >
                        <router-link :to="$i18nHelper.getUrl('employee/' + employee.id)" class="d-none d-sm-block ml-2">
                            &ensp;{{ employee.givenName + ' ' + employee.familyName }}
                        </router-link>
                        <router-link :to="$i18nHelper.getUrl('employee/' + employee.id)" class="d-block d-sm-none ml-1">
                            {{ employee.givenName }}
                        </router-link>
                    </div>
                </td>
                <td v-if="employee.employeePositions" class="d-none d-xl-table-cell">
                    {{ employee.employeePositions[0].name}}
                </td>
                <td class="d-none d-md-table-cell" :style="getStyle(employee)">
                    <span @click="makeSalaryVisible(employee.id)">
                        {{ showCurrencyById(employee.employeeInformation.currency.id, employee.employeeInformation.salary) }}
                    </span>
                </td>
                <td class="d-none d-md-table-cell">
                    <span v-if="employee.employeeInformation.bonus">{{ employee.employeeInformation.bonus }}</span>
                    <span v-else>-</span>
                </td>
                <td v-if="employee.employeeSalaries.length" class="d-none d-md-table-cell">
                    {{ employee.employeeSalaries[0].totalPayedSalary }}
                </td>
                <td v-else>
                    -
                </td>
                <td v-if="employee.employeeSalaries.length">
                    <b-form-input
                        class="border-gray-300 h-11 focus:ring-0"
                        :min="employee.employeeSalaries[myIndex].salaryOf"
                        type="month"
                        :readonly="isDisabledInput(employee)"
                        v-model="employee.employeeSalaries[myIndex].salaryOf"
                        @change="change(employee.employeeSalaries[myIndex], employee)"
                    />
                </td>
                <td v-else>
                    <b-form-input
                        id="date"
                        type="month"
                        v-model="employee.salaryOf"
                        class="border-gray-300 h-11 focus:ring-0"
                    />

                </td>
                <td>
                    <div class="d-flex">
                        <div class="d-flex h-11 border-gray-300 form-control px-1">
                            <input
                                :disabled="isDisabledInput(employee)"
                                class="col-8"
                                style="border: none; outline: none;"
                                v-model="employee.payedAmount"
                                @input="check(employee.payedAmount, index)"
                                type="number"
                                min="0"
                            />
                            <b-button
                                size="md"
                                style="padding: 0; height: 38px; width: 100px; background-color: #6f42c1"
                                type="submit"
                                class="btn col-4 -mt-1 ml-0.5"
                                :disabled="isDisabledInput(employee) || isShowCheckbox"
                                @click="payTotal(index)"
                            >
                                <span
                                    v-show="isLoading"
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                >
                                </span>
                                {{ $t('filter.all') }}
                            </b-button>
                        </div>
                        <button
                            v-if="!isShowCheckbox && !isDisabledInput(employee)"
                            type="submit"
                            class="btn bg-main rounded h-10 mt-0.5 text-white font-bold"
                            :disabled="disabledIndex === index || employee.payedAmount === ''"
                            @click.prevent="pay(index)"
                        >
                            <span
                                v-show="isLoading"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true">
                            </span>
                            {{ $t('pay') }}
                        </button>
                        <button
                            v-if="!isShowCheckbox && isDisabledInput(employee)"
                            type="submit"
                            class="btn bg-main rounded h-10 mt-0.5 text-white font-bold text-xs"
                            :disabled="false"
                            @click="showNewMonthPayModal(employee)"
                        >
                            <span
                                v-show="isLoading"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true">
                            </span>
                            {{ $t('kpi.salary.forNewMonth') }}
                        </button>
                    </div>
                </td>
            </tr>

            <tr v-if="employee.employeeSalaries.length && employeeId === employee.id">
                <td colspan="10">
                    <div class="row">
                        <div class="col-12">
                            <div v-for="salaryEmployee of employee.employeeSalaries" :key="salaryEmployee.id" class="mb-2">
                                <div class="card">
                                    <div class="text-center mt-2 font-weight-bold">{{ $t('kpi.salary.historyOfPay') }}</div>

                                    <HrRow class="px-3 mt-n2" />

                                    <div class="d-flex justify-content-around font-weight-bold">
                                        <div>{{ $t('kpi.salary.forWhatMonth') }}</div>
                                        <div>{{ $t('kpi.salary.totalPayed') }}</div>
                                    </div>
                                    <div class="d-flex justify-content-around">
                                        <div>{{ monthFormat(salaryEmployee.salaryOf) }}</div>
                                        <div @click="makeSalaryListVisible(salaryEmployee.id)" style="text-decoration: underline; color: #2C0FDE; cursor: pointer">
                                            {{ $t('kpi.salary.more') }} <span v-if="salaryEmployeeId === salaryEmployee.id">🠥</span> <span v-else>🠧</span>
                                        </div>
                                        <div>{{ showCurrencyByIdWithoutSymbol(3, salaryEmployee.totalPayedSalary) }}</div>
                                    </div>
                                </div>

                                <div v-if="salaryEmployeeId === salaryEmployee.id" class="row my-2">
                                    <div class="col-8 offset-2 card">
                                        <div class="d-flex justify-content-around mt-2 font-weight-bold">
                                            <div>{{ $t('kpi.salary.payDate') }}</div>
                                            <div>{{ $t('kpi.salary.payedAmount') }}</div>
                                        </div>

                                        <HrRow class="mt-n2" />

                                        <div v-for="salary of salaryEmployee.salaries" :key="salary.id">
                                            <div class="d-flex justify-content-around">
                                                <div>{{ dateFormat(salary.payedAt) }}</div>
                                                <div>{{ showCurrencyByIdWithoutSymbol(3, salary.payedAmount) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <!--  mobile version  -->
        <table class="w-full d-md-none">
            <tbody v-for="(employee, index ) of getEmployeeSalaries" :key="index" style="border-bottom: 5px solid dimgray">
                <tr class="h-11">
                    <th></th>
                    <td v-if="isShowCheckbox">
                        <b-form-checkbox
                            v-if="!isDisabledInput(employee)"
                            class=""
                            size="lg"
                            :value=employee.id
                            v-model="selectedEmployees"
                        />
                    </td>
                    <td v-if="!isShowCheckbox"></td>
                </tr>
                <tr class="h-11 bg-lightGray">
                    <th class=" pl-3">{{$t('id')}}</th>
                    <td class="">
                        {{ employee.id }}
                    </td>
                </tr>
                <tr class="h-11">
                    <th class=" pl-3">{{ $t('name') }}</th>
                    <td>
                        <div class="d-flex align-items-center">
                            <img
                                :src="employee.image ? url + employee.image.contentUrl : ''"
                                style="border-radius: 50%;"
                                height="34px"
                                alt=""
                                @click="setModal(employee.givenName, url + employee.image.contentUrl)"
                                class="d-none d-md-table-cell"
                            >
                            <router-link :to="$i18nHelper.getUrl('employee/' + employee.id)" class="d-none d-sm-block ml-2">
                                &ensp;{{ employee.givenName + ' ' + employee.familyName }}
                            </router-link>
                            <router-link :to="$i18nHelper.getUrl('employee/' + employee.id)" class="d-block d-sm-none ml-1">
                                {{ employee.givenName }}
                            </router-link>
                        </div>
                    </td>
                </tr>
                <tr class="h-11">
                    <th class=" pl-3">{{ $t('employee.position') }}</th>
                    <td v-if="employee.employeePositions" class="">
                        {{ employee.employeePositions[0].name}}
                    </td>
                </tr>
                <tr class="h-11">
                    <th class=" pl-3">{{ $t('employee.salary') }}</th>
                    <td class="" :style="getStyle(employee)">
                    <span @click="makeSalaryVisible(employee.id)">
                        {{ showCurrencyById(employee.employeeInformation.currency.id, employee.employeeInformation.salary) }}
                    </span>
                    </td>
                </tr>
                <tr class="h-11">
                    <th class=" pl-3">{{ $t('kpi.bonus.title') }}</th>
                    <td class="">
                        <span v-if="employee.employeeInformation.bonus">{{ employee.employeeInformation.bonus }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr class="h-11">
                    <th class="pl-3">{{ $t('kpi.salary.payed') }}</th>
                    <td v-if="employee.employeeSalaries.length" class="">
                        {{ employee.employeeSalaries[0].totalPayedSalary }}
                    </td>
                    <td v-else>
                        -
                    </td>
                </tr>
                <tr class="h-11">
                    <th class="pl-3">{{ $t('kpi.salary.forWhatMonth') }}</th>
                    <td v-if="employee.employeeSalaries.length">
                        <b-form-input
                            :min="employee.employeeSalaries[myIndex].salaryOf"
                            type="month"
                            :readonly="isDisabledInput(employee)"
                            v-model="employee.employeeSalaries[myIndex].salaryOf"
                            @change="change(employee.employeeSalaries[myIndex], employee)"
                        />
                    </td>
                    <td v-else>
                        <b-form-input
                            id="date"
                            type="month"
                            v-model="employee.salaryOf"
                        />

                    </td>
                </tr>
                <tr class="h-11">
                    <th class="pl-3" style="width: 300px">{{ $t('kpi.salary.pay') }}</th>
                    <td>
                        <div class="d-flex">
                            <div class="d-flex form-control px-1 py-1">
                                <input
                                    :disabled="isDisabledInput(employee)"
                                    class="col-8"
                                    style="border: none; outline: none;"
                                    v-model="employee.payedAmount"
                                    @input="check(employee.payedAmount, index)"
                                    type="number"
                                    min="0"
                                />
                                <b-button
                                    size="md"
                                    style="padding: 0; height: 30px; width: 100px; background-color: #6f42c1"
                                    type="submit"
                                    class="btn col-4"
                                    :disabled="isDisabledInput(employee) || isShowCheckbox"
                                    @click="payTotal(index)"
                                >
                                <span
                                    v-show="isLoading"
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                >
                                </span>
                                    {{ $t('filter.all') }}
                                </b-button>
                            </div>
                            <button
                                v-if="!isShowCheckbox && !isDisabledInput(employee)"
                                type="submit"
                                class="form-control btn col-3 ml-1 text-white"
                                style="background-color: #17A2B8"
                                :disabled="disabledIndex === index || employee.payedAmount === ''"
                                @click.prevent="pay(index)"
                            >
                            <span
                                v-show="isLoading"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true">
                            </span>
                                {{ $t('pay') }}
                            </button>
                            <button
                                v-if="!isShowCheckbox && isDisabledInput(employee)"
                                type="submit"
                                class="btn col-3 ml-1 text-white font-weight-bold"
                                style="background-color: #17A2B8; font-size: 11px; line-height: 1.0"
                                :disabled="false"
                                @click="showNewMonthPayModal(employee)"
                            >
                            <span
                                v-show="isLoading"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true">
                            </span>
                                {{ $t('kpi.salary.forNewMonth') }}
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <ModalWithPicture id="employee_picture" :img="itemImageUrl" :title="employeeGivenName"/>

        <SubmitRow
            v-if="isShowCheckbox"
            class="mt-5 float-right"
            text="pay"
            sm-size="12"
            md-size="12"
            :is-loading="isLoading"
            :is-disabled="isDisabledPayButton"
            :do-action="payMany"
        />

    </Row>
</template>

<script>
import ModalWithPicture from "@/components/html/ModalWithPicture.vue";
import Row from "@/components/html/Row.vue";
import SearchCollapse from "@/components/SearchCollapse.vue";
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "@/mixin/validatorMixin";
import accessMixin from "@/mixin/accessMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import SubmitRow from "@/components/SubmitRow.vue";
import Modal from "@/components/html/Modal.vue";
import HrRow from "@/components/html/HrRow.vue";

export default {
    name: "List",
    components: {
        HrRow,
        Modal,
        SubmitRow,
        SearchCollapse,
        Row,
        ModalWithPicture
    },
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, currencyRateMixin, dateFormattingMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees'},
                {name: 'kpi.salary.salary'},
            ],
            myIndex: 0,
            companyCounts: [],
            modalText: '',
            isDisabled: false,
            disabledIndex: null,
            isLoading: false,
            employeeGivenName: '',
            itemImageUrl: '',
            employee: null,
            employeeId: null,
            salaryEmployeeId: null,
            url: process.env.VUE_APP_API_URL,
            isShowCheckbox: false,
            isSelectedAll: false,
            selectedEmployees: [],
            search: {
                employeeGivenName: '',
                employeeFamilyName: '',
                employeeTelephone: '',
                page: 1
            },
            modelForm: {
                isAllEmployee: false,
                salaryOf: null,
                companyCount: null,
                employeeSalaryDtos: []
            },
            payedAmount: null,
            errors: {
                salaryOf: null,
            },
            optionsMonth: [
                {value: 1, text: this.$t('statistics.month.Jan')},
                {value: 2, text: this.$t('statistics.month.Feb')},
                {value: 3, text: this.$t('statistics.month.Mar')},
                {value: 4, text: this.$t('statistics.month.Apr')},
                {value: 5, text: this.$t('statistics.month.May')},
                {value: 6, text: this.$t('statistics.month.Jun')},
                {value: 7, text: this.$t('statistics.month.Jul')},
                {value: 8, text: this.$t('statistics.month.Aug')},
                {value: 9, text: this.$t('statistics.month.Sep')},
                {value: 10, text: this.$t('statistics.month.Oct')},
                {value: 11, text: this.$t('statistics.month.Nov')},
                {value: 12, text: this.$t('statistics.month.Dec')},
            ],
        }
    },
    computed: {
        ...mapGetters(['getEmployeeSalaries', 'getEmployeeSalariesTotalCount', 'getCompanyCounts']),
        isDisabledPayButton() {
            if (this.selectedEmployees.length === 0) {
                return true
            }

            for (let id of this.selectedEmployees) {
                if(!+this.getEmployeeSalaries.find((employee) => employee.id === id).payedAmount) {
                    return true
                }
            }

            return false
        },
    },
    methods: {
        ...mapActions(['fetchEmployeeSalaries', 'pushSalary', 'fetchCompanyCountsAll', 'setBreadcrumbItems']),
        isDisabledInput(employee) {
            let totalSalary = +employee.employeeInformation.salary + +employee.employeeInformation.bonus

            if (employee.employeeSalaries.length === 0) {
                return false
            }

            let totalPayedAmount = +employee.employeeSalaries[0].totalPayedSalary
            return totalPayedAmount >= totalSalary
        },
        monthFormat(plainVal) {
            plainVal += '-01'
            let date = new Date(plainVal);

            return this.optionsMonth.find((month) => month.value === date.getMonth() + 1).text + ' ' + date.getFullYear();
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        setModal(givenName, url) {
            this.employeeGivenName = givenName
            this.itemImageUrl = url
            this.$bvModal.show('employee_picture')
        },
        getStyle(employee) {
            if (employee.employeeSalaries.length) {
                return 'color: #2C0FDE; text-decoration: underline; cursor: pointer;'
            }
        },
        searchEmployees() {
            this.$root.showOverlay = true
            this.searchEmployee(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        makeSalaryListVisible(id) {
            if (this.salaryEmployeeId) {
                this.salaryEmployeeId = null
            } else {
                this.salaryEmployeeId = id
            }
        },
        makeSalaryVisible(id) {
            if (this.employeeId) {
                this.employeeId = null
            } else {
                this.employeeId = id
            }
        },
        resetEmployeeSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchEmployees()
        },
        paySalary() {
            this.$root.showOverlay = true
            this.modelForm.salaryOf = this.employee.salaryOf + '-01'
            this.modelForm.employeeSalaryDtos.push(
                {
                    person: this.employee['@id'],
                    payedAmount: this.employee.payedAmount.toString(),
                    salaryOf: this.employee.salaryOf + '-01'
                })
            this
                .pushSalary(this.modelForm)
                .then(() => {
                    this.fetchEmployeeSalaries()
                    this.$root.showOverlay = false
                    this.$bvModal.hide('select-count-modal')
                    this.$bvModal.hide('pay-modal')
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        showSelectedModal() {
            this.$bvModal.show('select-count-modal')
        },
        payForNewMonth() {
            this.$root.showOverlay = true
            console.log('1 ga keldi')
            let data = {}
            data.companyCount = this.modelForm.companyCount
            data.salaryOf = this.modelForm.salaryOf + '-01'
            data.employeeSalaryDtos = []
            data.employeeSalaryDtos.push(
                {
                    person: this.employee['@id'],
                    payedAmount: this.payedAmount.toString(),
                    salaryOf: this.modelForm.salaryOf + '-01'
                })

            this
                .pushSalary(data)
                .then(() => {
                    this.fetchEmployeeSalaries()
                    this.$root.showOverlay = false
                    this.$bvModal.hide('pay-new-month-modal');
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        showNewMonthPayModal(employee) {
            this.modelForm.salaryOf = new Date().toISOString().slice(0,7)
            this.$bvModal.show('pay-new-month-modal')
            this.employee = employee
        },
        payTotal(index) {
            this.$bvModal.show('pay-modal');
            this.getEmployeeSalaries[index].payedAmount = this.calcResidueSalary(index)
            this.employee = this.getEmployeeSalaries[index]
        },
        calcResidueSalary(index) {
            if (this.getEmployeeSalaries[index].employeeSalaries.length) {
                return (+this.getEmployeeSalaries[index].employeeInformation.salary +
                    +this.getEmployeeSalaries[index].employeeInformation.bonus) -
                    +this.getEmployeeSalaries[index].employeeSalaries[0].totalPayedSalary
            }

            return (+this.getEmployeeSalaries[index].employeeInformation.salary +
                +this.getEmployeeSalaries[index].employeeInformation.bonus)
        },
        hidePayModal() {
            this.$bvModal.hide('pay-modal')
            this.employee.payedAmount = ''
        },
        hideSelectCountModal() {
            this.$bvModal.hide('select-count-modal')
            this.hidePayModal()
        },
        pay(index) {
            this.$bvModal.show('pay-modal');
            this.employee = this.getEmployeeSalaries[index]
        },
        showCheckboxes() {
            this.isShowCheckbox = !this.isShowCheckbox
        },
        selectAll() {
            if (this.isSelectedAll) {
                this.selectedEmployees = []
            } else {
                this.selectedEmployees = []

                for (let employee of this.getEmployeeSalaries) {
                    if(!this.isDisabledInput(employee)) {
                        this.selectedEmployees.push(employee.id)
                    }
                }
            }
        },
        payMany() {
            this.$root.showOverlay = true

            let data = {}
            data.employeeSalaryDtos = []

            for (let item of this.selectedEmployees) {
                data.employeeSalaryDtos.push(
                    {
                        person: '/api/people/' + item,
                        payedAmount: this.getEmployeeSalaries.find((employee) => employee.id === item).payedAmount,
                        salaryOf: this.getEmployeeSalaries.find((employee) => employee.id === item).salaryOf + '-01'
                    })
            }

            this
                .pushSalary(data)
                .then(() => {
                    this.fetchEmployeeSalaries()
                    this.$root.showOverlay = false
                    this.$bvModal.hide('pay-modal');
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        check(input, index) {
            if (input.toString() > '1') {
                this.disabledIndex = null
                return
            }

            this.disabledIndex = index
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this
            .fetchEmployeeSalaries()
            .then(() => {
                this.$root.showOverlay = false
                this.fetchCompanyCountsAll()
                    .then(() => {
                        this.companyCounts = this.getCompanyCounts.slice()
                        for (let companyCount of this.getCompanyCounts) {
                            if(companyCount.name === 'Main') {
                                companyCount.name = this.$t('main')
                            }
                        }
                    })
            })
            .catch((reason) => {
                this.$root.showOverlay = false

                this.modalText = reason
                this.$bvModal.show('modal_show')
            })
    }
}
</script>

<style scoped>

</style>